import { Box, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { countries } from "country-flags-svg-v2";
import useStyles from "./index.styles";

interface CountrySelectProps {
  country: string;
  onChange: (value: string) => void;
}

export const CountrySelect = ({ country, onChange }: CountrySelectProps) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.countrySelectBox}>
      <Select
        value={country}
        displayEmpty
        onChange={(event: SelectChangeEvent<string>) =>
          onChange(event.target.value)
        }
        IconComponent={ExpandMoreIcon}
        inputProps={{
          MenuProps: {
            PaperProps: {
              sx: {
                backgroundColor: "#16191a",
                color: "white",
              },
            },
            children: {
              sx: {
                fontSize: "12px",
              },
            },
          },
        }}
      >
        {countries.map((country, index) => (
          <MenuItem key={index} value={country.name} sx={{ color: "white" }}>
            {country.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
